// extracted by mini-css-extract-plugin
export var dividerContainer = "_7w-0";
export var line = "_7w-1";